(() => {
  if (window.FoldingLinkAppStory) return;

  const initWorkflow = (root) => {
    if (root.dataset.foldinglinkAppStoryInit === 'true') return;

    const track = root.querySelector('[data-foldinglink-app-story-track]');
    const stages = Array.from(root.querySelectorAll('[data-foldinglink-app-story-stage]'));
    const previous = root.querySelector('[data-foldinglink-app-story-previous]');
    const next = root.querySelector('[data-foldinglink-app-story-next]');
    const counter = root.querySelector('[data-foldinglink-app-story-counter]');
    const dots = Array.from(root.querySelectorAll('.foldinglink-app-story__dots span'));
    if (!track || !stages.length) return;

    root.dataset.foldinglinkAppStoryInit = 'true';
    const abortController = new AbortController();
    const options = { signal: abortController.signal };
    const passiveOptions = { passive: true, signal: abortController.signal };
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let scrollFrame = 0;

    const updateState = (index) => {
      activeIndex = Math.max(0, Math.min(stages.length - 1, index));
      stages.forEach((stage, stageIndex) => stage.classList.toggle('is-current', stageIndex === activeIndex));
      dots.forEach((dot, dotIndex) => dot.classList.toggle('is-current', dotIndex === activeIndex));
      if (counter) counter.textContent = `${String(activeIndex + 1).padStart(2, '0')} / ${String(stages.length).padStart(2, '0')}`;
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === stages.length - 1;
    };

    const scrollToStage = (index) => {
      const targetIndex = Math.max(0, Math.min(stages.length - 1, index));
      track.scrollTo({
        left: stages[targetIndex].offsetLeft,
        behavior: reduceMotion.matches ? 'auto' : 'smooth'
      });
      updateState(targetIndex);
    };

    const syncFromScroll = () => {
      scrollFrame = 0;
      let nearestIndex = 0;
      let nearestDistance = Number.POSITIVE_INFINITY;
      stages.forEach((stage, index) => {
        const distance = Math.abs(stage.offsetLeft - track.scrollLeft);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearestIndex = index;
        }
      });
      updateState(nearestIndex);
    };

    track.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = requestAnimationFrame(syncFromScroll);
    }, passiveOptions);
    previous?.addEventListener('click', () => scrollToStage(activeIndex - 1), options);
    next?.addEventListener('click', () => scrollToStage(activeIndex + 1), options);

    root.foldinglinkDestroyAppStory = () => {
      abortController.abort();
      if (scrollFrame) cancelAnimationFrame(scrollFrame);
      delete root.dataset.foldinglinkAppStoryInit;
      delete root.foldinglinkDestroyAppStory;
    };

    updateState(0);
  };

  const init = (scope = document) => {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-foldinglink-app-story]')) roots.push(scope);
    roots.push(...scope.querySelectorAll('[data-foldinglink-app-story]'));
    roots.forEach(initWorkflow);
  };

  window.FoldingLinkAppStory = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-foldinglink-app-story]')
      ? event.target
      : event.target.querySelector?.('[data-foldinglink-app-story]');
    root?.foldinglinkDestroyAppStory?.();
  });
})();
